//Copyright (C) Siemens Healthineers AG 2024, All rights reserved. Restricted
//
(function () {
    'use strict';

    angular
        .module('container.util')
        .factory('operatorClientService', operatorClientService);


    function operatorClientService($rootScope, $q, $filter, Event, OPERATOR_CLIENT_URL, OC_ENABLED, OC_MAX_TRIES, authenticationService, tokenExchangeService, ConfigurationResource, operatorClientStatService, userSettingsService) {

        var service = {};
        var operatorClientTriggered = false;
        var regionalInstanceKey;
        var initStatServiceRetries = 0;
        var notConnectedCallbacks = [];

        service.init = function() {
            var d = $q.defer();

            ConfigurationResource.getRegionalInstanceKey({}, function(response) {
                regionalInstanceKey = response.value;
                d.resolve();
            }, function(error) {
                const errorMessage = $filter('translate')(error.data ? error.data.message : 'error while getting regional instance key') + ': ' + error.data ? error.data.error : '';
                console.log(errorMessage);
                d.reject();
            });

            return d.promise;
        }


        service.trigger = function(force) {

            if (!operatorClientTriggered || force) {
                const gid = authenticationService.profile ? authenticationService.profile.username : '';
                const accessToken = authenticationService.token || '';
                tokenExchangeService.getExchangeToken(accessToken).then((exchangeToken) => {
                    const fullUrl = `${OPERATOR_CLIENT_URL}?gid=${gid}&hideParameters=true&accessToken=${exchangeToken}&instance=${regionalInstanceKey}&processKeepAliveTimeout=120000`;
                    window.location = fullUrl;
                    setTimeout(() => {
                        console.info('Triggered operator client via', fullUrl);
                        service.triggerStatService();
                    }, 5000);
                    operatorClientTriggered = true;
                });
            }
        };

        service.triggerStatService = function() {

            if ((initStatServiceRetries === 0 || initStatServiceRetries >= OC_MAX_TRIES) && OC_ENABLED === 'true') {
                initStatServiceRetries = 0;
                service.initStatService();
            } else {
                initStatServiceRetries = 0;
            }
        }

        service.initStatService = function() {
            setTimeout(() => {
                initStatServiceRetries++;
                operatorClientStatService.getOperatorClientCcpId().then((success) => {
                    operatorClientStatService.start();
                    $rootScope.$emit(Event.OC_RESTARTED);
                }, () => {
                    if (initStatServiceRetries <= OC_MAX_TRIES) {
                        console.log(`init of operatorClientStatService failed! This is Try ${initStatServiceRetries}/${OC_MAX_TRIES}`);
                        service.initStatService();
                    } else {
                        console.log(`init of operatorClientStatService failed! No more tries`);
                        notConnectedCallbacks.forEach(callback => callback());
                    }
                });
            }, 1000);
        }

        $rootScope.$on(Event.USER_LOGGED_OUT, () => {
            operatorClientTriggered = false;
        })

        service.init().then((success) => {
            userSettingsService.loadUserSetting('container', 'disableOCDefaultTrigger')
                .then(disableOCDefaultTrigger => {
                    if (disableOCDefaultTrigger !== true && OC_ENABLED === 'true') {
                        service.trigger();
                    }
                }, () => {
                    //Trigger oc as default
                    service.trigger();
                });
        }, () => {
            console.log('init of operatoreClientService failed!');
        })

        service.addNotConnectedCallbacks = function(callback) {
            if (notConnectedCallbacks.includes(callback)) {
                console.warn('OperatorClientService notConnectedCallback was already registered, not registering again');
                return;
            }

            notConnectedCallbacks.push(callback);
        }

        service.removeNotConnectedCallbacks = function(callback) {
            if (!notConnectedCallbacks.includes(callback)) {
                console.warn('OperatorClientService notConnectedCallback was not registered, not removing from callbacks');
                return;
            }

            notConnectedCallbacks = notConnectedCallbacks.filter(call => call !== callback);
        }

        return service;
    }
})();